import { render } from "./AwardDetailJun2023Page.vue?vue&type=template&id=3fe1e6c2"
import script from "./AwardDetailJun2023Page.vue?vue&type=script&lang=js"
export * from "./AwardDetailJun2023Page.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__